module.exports = __webpack_public_path__ + "static/recruitbtn-c941db35e01c73ea50a85ab227dd588e.png";